import _ from "lodash";
import uuid from "react-uuid";

import { FilePlus, ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

import { TableItem } from "./TableItem";
import { useTable, get } from "./useTable";

import { Config } from "../Config";
import { TableConfig } from "./TableConfig";
import { useTableContext } from "./TableContext";

import { TableHeader as Container, TableHeaderButton, TableHeaderSortButton } from "./styles";

function parseColumnProps(name) {
  const [columnName, className] = name.split("|");

  return {
    name: columnName.replace(/#/g, ""),
    className: className || "",
  }
}

export function TableHeader({ columns = [], sortableConfig }) {
  const { tableName } = useTableContext();
  const data = useTable((st) => st.data);
  const setColumns = useTable((st) => st.actions.setColumns);

  const table = get.table(data.tables, tableName);
  const columnsList = get.columns(data.columns[tableName], "*");

  setColumns(
    tableName,
    columns.map((column) => {
      if (!column) return { name: "", size: "" };
      const [name, size, hidden] = column.split(":");
      return {
        id: uuid(),
        size: size || "1fr",
        hidden: !!hidden || false,
        ...parseColumnProps(name),
      };
    })
  );

  const lastColumn = _.last(columnsList);
  const columnsSize = columnsList
    .filter((column) => !_.isEmpty(column.name.trim()))
    .map((column) => (!column.hidden ? column.size : "0fr"))
    .join(" ");

  const columnsStyle = `${columnsSize} ${table?.config ? "minmax(40px, 1fr)" : ""} ${table?.customActions ? lastColumn.size : ""} ${table?.action ? "70px" : ""}`;

  const sortBy = sortableConfig?.sortBy;
  const sortOrder = sortableConfig?.sortOrder;
  const onSort = sortableConfig?.onSort;
  const columnKeys = sortableConfig?.columnKeys || {};

  const renderHeaderCell = (column) => {
    const label = column.name.replace(/[#_]/g, "");
    const sortKey = columnKeys[label];
    const isSortable = !!sortKey && typeof onSort === "function";

    if (isSortable && !column.hidden) {
      const isActive = sortBy === sortKey;
      const SortIcon = isActive ? (sortOrder === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;
      return (
        <TableHeaderSortButton
          key={`${tableName}-${column.id}`}
          type="button"
          style={{ maxWidth: column.size }}
          onClick={() => onSort(sortKey)}
          title={`Ordenar por ${label}`}
        >
          <span>{label}</span>
          <SortIcon size={16} style={{ flexShrink: 0 }} />
        </TableHeaderSortButton>
      );
    }

    return (
      <TableItem
        key={`${tableName}-${column.id}`}
        style={{ maxWidth: column.size }}
        tableName={tableName}
        className={column.className}
      >
        {label}
      </TableItem>
    );
  };

  return (
    <Container columns={columnsStyle}>
      {columnsList
        .filter((column) => !_.isEmpty(column.name.trim()))
        .filter((column) => column.name)
        .map((column) => renderHeaderCell(column))}
      {!!table?.config && (
        <Config name={`${tableName}-config`} twoColunms={!!table?.customActions} option={table.config}>
          <TableConfig tableName={tableName} />
        </Config>
      )}
      {!!table?.action && (
        <TableHeaderButton type="button" data-hidden={table.action?.add === 'hidden'} disabled={!table.action?.add} onClick={table.action?.add}>
          <FilePlus size={20} />
        </TableHeaderButton>
      )}
    </Container>
  );
}
